import React from "react";
import { FormattedMessage } from "react-intl";
import globalMessages from "../../../intl/globalMessages";
import GeneralTranslations from "../../../Common/ModuleTranslations/es";

export default {
  locale: "es",
  name: "Formularios",
  translation: { displayName: "Traducciones" },
  fields: {
    /** Here are te entities used in the lists, Order is important */
    /** fieldName: this is used like the id container of the properties */
    /** displayName: this is the title rendered */
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "active",
        widget: "singleSwitch",
        toggleAction: true,
        displayName: "Active",
      },
      {
        fieldName: "dependers",
        searchCriteria: "type",
        fieldSelector: {
          EXTRA: "Extras",
          GUEST_FORM: "Formulario huésped",
          CANCELLATION_FORM: "Modal cancelación",
          ROOMSTAY_CHECKOUT: "Formulario de check-out",
        },
        displayName: "Habilitar Para",
      },
    ],
    /** Here is the entity used in the forms, Order is important */
    /** all the properties can be found in app/components/CRUD/Common, at the corresponding js file */
    /** fieldName: is like the id in html, it must be unique among the attributes */
    /** widget: is used to render the kind of interaction the user will have, a complete list can be found in component/CRUD/Common */
    /** displayName: The text that introduces the widget */
    /** defaultValue: The default value of the widget */
    /** optionDisplay: An object that containes objects with the option at the select */
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "propertyTicker",
        widget: "hidden",
      },
      {
        fieldName: "active",
        displayName: "Activo",
        widget: "singleSwitch",
        className: "activeCheckbox",
      },
      {
        fieldName: "dependers",
        displayName: "Habilitar para",
        widget: "selector",
        optionDisplay: {
          EXTRA: {
            label: "Extras",
          },
          GUEST_FORM: {
            label: "Formulario huésped",
          },
          CANCELLATION_FORM: {
            label: "Modal cancelación",
          },
          ROOMSTAY_CHECKOUT: {
            label: "Check-out: RoomStay",
          },
        },
        defaultValue: "EXTRA",
      },
      {
        fieldName: "dependersBoxes",
        widget: "multicheckbox",
        displayName: "Listado de extras",
        selectables: true,
        selectAllText: <FormattedMessage {...globalMessages.selectAll} />,
        selectNoneText: <FormattedMessage {...globalMessages.selectNone} />,
        visible: ({ formValues }) => {
          return formValues.dependers === "EXTRA";
        },
      },
      {
        /** In nested entities the fieldName must be used in the form so it knows which entities must be declared respectively. No need to put in the router the components*/
        fieldName: "fields",
        displayName: "Preguntas",
        introductionText: "El orden de las preguntas se verá reflejado en el formulario",
        widget: "nestedEntity",
        nestedTitle: "Edición",
        nested: true,
        entityName: "CancellationPolicyConfiguration",
        defaultValue: [],
      },
    ],
  },
};
